import React, { useState } from "react";
import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import bkstApi from "../../api";
import ProgressRing from "./ProgressRing";
import ProgressStepper from "./ProgressStepper";

export function saveItemProgress(orderId, itemIndex, item, progress) {
  return bkstApi.put(`/my/order/${orderId}/progress`, {
    itemIndex,
    item: {
      productId: item.productId,
      quantity: item.quantity,
      total: item.total,
      variant: item.variant,
    },
    progress,
  });
}

// Clicking a step marks it complete; clicking an already completed step reopens it.
export function getStepAfterClick(clickedStep, currentStep) {
  return clickedStep < currentStep ? +clickedStep : +clickedStep + 1;
}

export default function ItemProgress(props) {
  const { orderId, item, itemIndex, onChange, size } = props;

  const [progress, setProgress] = useState(props.progress);
  const [activeStep, setActiveStep] = useState(progress.step);

  const [open, setOpen] = useState(false);
  const [error, setError] = useState("");

  const updateProgress = () => {
    const data = { step: activeStep, steps: progress.steps };

    setError("");
    saveItemProgress(orderId, itemIndex, item, data)
      .then((res) => {
        setProgress(data);
        setOpen(false);
        if (onChange) {
          onChange(res.data);
        }
      })
      .catch((err) => {
        setError(err.response?.data?.message || "An error occurred while saving progress");
      });
  };

  const handleStepClick = (step) => {
    setActiveStep(getStepAfterClick(step, progress.step));
  };

  const handleClose = () => {
    setActiveStep(progress.step);
    setError("");
    setOpen(false);
  };

  return (
    <span style={{ display: "inline-flex", alignItems: "center" }}>
      <ProgressRing
        pct={(progress.step * 100) / progress.steps.length}
        onClick={() => setOpen(true)}
        size={size}
      />
      <Dialog open={open} onClose={handleClose} fullWidth={true} maxWidth="sm">
        <DialogTitle>Item Progress</DialogTitle>
        <IconButton
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <Box textAlign={"center"}>
            <Typography variant="body1" color="textSecondary">
              A great way to keep track of your item progress. Simply click a step & confirm to mark
              it complete!
            </Typography>
          </Box>
          <Box my={4}>
            <ProgressStepper
              steps={progress.steps}
              activeStep={activeStep}
              onStepClick={handleStepClick}
            />
          </Box>
          {error && <Alert severity="error">{error}</Alert>}
        </DialogContent>
        <DialogActions>
          <Box sx={{ height: "36.5px" }}>
            {activeStep !== progress.step && (
              <Box>
                <Button color="secondary" onClick={handleClose} sx={{ marginRight: "1rem" }}>
                  CANCEL
                </Button>
                <Button color="primary" variant="contained" onClick={updateProgress}>
                  SAVE CHANGES
                </Button>
              </Box>
            )}
          </Box>
        </DialogActions>
      </Dialog>
    </span>
  );
}
